type TPartnerUserDocStatus =
  | 'nodoc'
  | 'approve_check'
  | 'approve_reject'
  | 'approve';
type TServiceActiveStatus = 'sign_up' | 'active' | 'suspended' | 'pause';
type TServiceDocStatus =
  | 'nodoc'
  | 'doc_wait'
  | 'doc_checked'
  | 'doc_reject'
  | 'interview_notice'
  | 'interview_answer'
  | 'interview_noanswer'
  | 'interview_progress'
  | 'interview_approve'
  | 'interview_nonapprove'
  | 'approve_check'
  | 'approve_reject'
  | 'approve';

export interface IPageProps {
  path: string;
  url: string;
  requiredLogin: boolean;
  serviceActiveStatus?: Array<TServiceActiveStatus>;
  serviceDocStatus?: Array<TServiceDocStatus>;
  partnerUserDocStatus?: Array<TPartnerUserDocStatus>;
}

/**
 * 메인
 */
export const MAIN: IPageProps = {
  path: '/',
  url: '/',
  requiredLogin: false,
};

/**
 * 파트너 가입
 */
export const SIGNUP: IPageProps = {
  path: '/partner/signup',
  url: '/partner/signup',
  requiredLogin: false,
};

/**
 * 파트너 설문
 */
export const SURVEY: IPageProps = {
  path: '/partner/survey',
  url: '/partner/survey',
  requiredLogin: false,
};

/**
 * 로그인
 */
export const LOGIN: IPageProps = {
  path: '/partner/login',
  url: '/partner/login',
  requiredLogin: false,
};

/**
 * 서비스 선택
 */
export const SERVICE_SELECT: IPageProps = {
  path: '/service',
  url: '/service',
  requiredLogin: true,
};

/**
 * 소형이사 조회
 */
export const SMALLMOVE_INFO: IPageProps = {
  path: '/service/smallmove',
  url: '/service/smallmove',
  requiredLogin: true,
  serviceActiveStatus: ['active'],
  serviceDocStatus: ['approve'],
};

/**
 * 소형이사 서류 등록
 */
export const SMALLMOVE_REGISTER: IPageProps = {
  path: '/service/register/smallmove',
  url: '/service/register/smallmove',
  requiredLogin: true,
};

/**
 * 소형이사 차량 등록
 */
export const SMALLMOVE_CARINFO_REGISTER: IPageProps = {
  path: '/service/car/register/smallmove',
  url: '/service/car/register/smallmove',
  requiredLogin: true,
};

/**
 * 가정이사 조회
 */
export const FAMILYMOVE_INFO: IPageProps = {
  path: '/service/familymove',
  url: '/service/familymove',
  requiredLogin: true,
  serviceActiveStatus: ['active'],
  serviceDocStatus: ['approve'],
};

/**
 * 유저 리스트 조회
 */
export const USER_LIST: IPageProps = {
  path: '/user/list/:serviceType/:serviceIdx',
  url: '/user/list',
  requiredLogin: true,
  serviceActiveStatus: ['sign_up', 'active'],
  serviceDocStatus: ['interview_approve', 'approve_reject', 'approve'],
};

/**
 * 유저 등록
 */
export const USER_REGISTER: IPageProps = {
  path: '/user/register/:serviceType/:serviceIdx',
  url: '/user/register',
  requiredLogin: true,
  serviceActiveStatus: ['sign_up', 'active'],
  serviceDocStatus: ['interview_approve', 'approve_reject', 'approve'],
};

/**
 * 가정이사 서류 등록
 */
export const FAMILYMOVE_REGISTER: IPageProps = {
  path: '/service/register/familymove',
  url: '/service/register/familymove',
  requiredLogin: true,
};

/**
 * 가정이사 차량 등록
 */
export const FAMILYMOVE_CARINFO_REGISTER: IPageProps = {
  path: '/service/car/register/familymove',
  url: '/service/car/register/familymove',
  requiredLogin: true,
};

/**
 * 이사청소 서류 등록
 */
export const MOVECLEANING_REGISTER: IPageProps = {
  path: '/service/register/movecleaning',
  url: '/service/register/movecleaning',
  requiredLogin: true,
};

/**
 * 이사청소 프로필 등록
 */
export const MOVECLEANING_PROFILE_REGISTER: IPageProps = {
  path: '/service/profile/register/movecleaning',
  url: '/service/profile/register/movecleaning',
  requiredLogin: true,
};

/**
 * 이사청소 조회
 * 인터뷰 승인 이후 프로필이나 제공 서비스를 등록하는 기능이 없기 때문에,
 * 인터뷰 승인이나, 승인 검토일 때도 /service 화면으로 이동하도록 작업
 */
export const MOVECLEANING_INFO: IPageProps = {
  path: '/service/move_cleaning',
  url: '/service/move_cleaning',
  requiredLogin: true,
  serviceActiveStatus: ['sign_up', 'active'],
  serviceDocStatus: ['interview_approve', 'approve_check', 'approve'],
};

/**
 * 파트너 가입 완료
 */
export const PARTNER_COMPLETED: IPageProps = {
  path: '/partner/signup/completed',
  url: '/partner/signup/completed',
  requiredLogin: false,
};

/**
 * 활동 승인거절
 */
export const SERVICE_APPROVEREJECT: IPageProps = {
  path: '/service/approve-reject/:serviceType/:serviceIdx',
  url: '/service/approve-reject',
  requiredLogin: true,
  serviceActiveStatus: ['sign_up'],
  serviceDocStatus: ['approve_reject'],
};

/**
 * 서류 확인
 */
export const SERVICE_DOCCHECKED: IPageProps = {
  path: '/service/doc-checked/:serviceType/:serviceIdx',
  url: '/service/doc-checked',
  requiredLogin: true,
  serviceActiveStatus: ['sign_up'],
  serviceDocStatus: ['doc_checked'],
};

/**
 * 서류 거절
 */
export const SERVICE_DOCREJECT: IPageProps = {
  path: '/service/doc-reject/:serviceType/:serviceIdx',
  url: '/service/doc-reject',
  requiredLogin: true,
  serviceActiveStatus: ['sign_up'],
  serviceDocStatus: ['doc_reject'],
};

/**
 * 서류 대기
 */
export const SERVICE_DOCWAIT: IPageProps = {
  path: '/service/doc-wait/:serviceType/:serviceIdx',
  url: '/service/doc-wait',
  requiredLogin: true,
  serviceActiveStatus: ['sign_up'],
  serviceDocStatus: ['doc_wait'],
};

/**
 * 인터뷰 고지
 */
export const SERVICE_INTERVIEWNOTICE: IPageProps = {
  path: '/service/interview-notice/:serviceType/:serviceIdx',
  url: '/service/interview-notice',
  requiredLogin: true,
  serviceActiveStatus: ['sign_up'],
  serviceDocStatus: ['interview_notice'],
};

/**
 * 인터뷰 응답
 */
export const SERVICE_INTERVIEWANSWER: IPageProps = {
  path: '/service/interview-answer/:serviceType/:serviceIdx',
  url: '/service/interview-answer',
  requiredLogin: true,
  serviceActiveStatus: ['sign_up'],
  serviceDocStatus: ['interview_answer', 'interview_progress'],
};

/**
 * 인터뷰 미응답
 */
export const SERVICE_INTERVIEWNOANSWER: IPageProps = {
  path: '/service/interview-noanswer/:serviceType/:serviceIdx',
  url: '/service/interview-noanswer',
  requiredLogin: true,
  serviceActiveStatus: ['sign_up'],
  serviceDocStatus: ['interview_noanswer'],
};

/**
 * 인터뷰 미승인
 * 이사청소의 경우 승인거절 시에 인터뷰 미승인 화면 표시하도록 작업
 */
export const SERVICE_INTERVIEWNOAPPROVE: IPageProps = {
  path: '/service/interview-noapprove/:serviceType/:serviceIdx',
  url: '/service/interview-noapprove',
  requiredLogin: true,
  serviceActiveStatus: ['sign_up'],
  serviceDocStatus: ['interview_nonapprove', 'approve_reject'],
};

/**
 * 인터뷰 승인
 */
export const SERVICE_INTERVIEWAPPROVE: IPageProps = {
  path: '/service/interview-approve/:serviceType/:serviceIdx',
  url: '/service/interview-approve',
  requiredLogin: true,
  serviceActiveStatus: ['sign_up'],
  serviceDocStatus: ['interview_approve', 'approve_check'],
};

/**
 * 서류 재등록
 */
export const DOC_REVIEW: IPageProps = {
  path: '/service/doc-review/:serviceType/:serviceIdx',
  url: '/service/doc-review',
  requiredLogin: true,
  serviceActiveStatus: ['sign_up'],
  serviceDocStatus: ['doc_reject'],
};

/**
 * 서류 상세
 * 이사 청소의 경우
 * 인터뷰 승인 이후 프로필이나 제공 서비스를 등록하는 기능이 없기 때문에,
 * 인터뷰 승인이나, 승인 검토일 때도 /service 화면으로 이동이 가능하여
 * certinfo도 접근 가능하도록
 */
export const CERT_INFO: IPageProps = {
  path: '/service/certinfo/:certName/:serviceType/:serviceIdx',
  url: '/service/certinfo',
  requiredLogin: true,
  serviceActiveStatus: ['sign_up', 'active'],
  serviceDocStatus: ['interview_approve', 'approve_check', 'approve'],
};

/**
 * 프로필 등록
 */
export const PROFILE_REGISTER: IPageProps = {
  path: '/service/profile/register/:serviceType/:serviceIdx',
  url: '/service/profile/register',
  requiredLogin: true,
  serviceActiveStatus: ['sign_up'],
  serviceDocStatus: ['interview_approve', 'approve_check', 'approve_reject'],
};

/**
 * 내 프로필
 */
export const MY_PROFILE: IPageProps = {
  path: '/service/profile/:serviceType/:serviceIdx',
  url: '/service/profile',
  requiredLogin: true,
  serviceActiveStatus: ['active'],
  serviceDocStatus: ['approve'],
};

/**
 * 유저 정보 조회
 */
export const USER_INFO: IPageProps = {
  path: '/user/info/:serviceType/:serviceIdx/:partnerUserIdx',
  url: '/user/info',
  requiredLogin: true,
  serviceActiveStatus: ['sign_up', 'active'],
  serviceDocStatus: ['approve', 'approve_check', 'approve_reject'],
};

/**
 * 유저 승인 대기 확인
 */
export const USER_APPROVE_CHECK: IPageProps = {
  path: '/user/approve-check/:serviceType/:serviceIdx/:partnerUserIdx',
  url: '/user/approve-check',
  requiredLogin: true,
  serviceActiveStatus: ['sign_up', 'active'],
  serviceDocStatus: [
    'approve',
    'approve_check',
    'approve_reject',
    'interview_approve',
  ],
};

/**
 * 유저 승인 거절
 */
export const USER_APPROVE_REJECT: IPageProps = {
  path: '/user/approve-reject/:serviceType/:serviceIdx/:partnerUserIdx',
  url: '/user/approve-reject',
  requiredLogin: true,
  serviceActiveStatus: ['sign_up', 'active'],
  serviceDocStatus: ['approve', 'approve_check', 'approve_reject'],
};

/**
 * 제공 서비스 등록
 */
export const SERVICE_FEATURE_REGISTER: IPageProps = {
  path: '/service/feature/register/:serviceType/:serviceIdx',
  url: '/service/feature/register',
  requiredLogin: true,
  serviceActiveStatus: ['sign_up'],
  serviceDocStatus: ['interview_approve', 'approve_check', 'approve_reject'],
};

/**
 * 제공 서비스 조회
 */
export const SERVICE_FEATURE: IPageProps = {
  path: '/service/feature/:serviceType/:serviceIdx/:searchType',
  url: '/service/feature',
  requiredLogin: true,
  serviceActiveStatus: ['active'],
  serviceDocStatus: ['approve'],
};

/**
 * 앱 사용 가이드
 */
export const APP_GUIDE: IPageProps = {
  path: '/app-guide/:serviceType',
  url: '/app-guide',
  requiredLogin: false,
};

/**
 * 시스템 체크 페이지
 */
export const SYSTEM_CHECK: IPageProps = {
  path: '/systemCheck',
  url: '/systemCheck',
  requiredLogin: false,
};
